import { Dispatch, AnyAction } from 'redux';
import { AppState } from '../redux';
import axios, { AxiosResponse, AxiosError } from 'axios';
import {
    STORE_PAIDINVOICE_DATA,
    PaidInvoiceData,
    MyInvoicesData,
    STORE_MYINVOICES_DATA,
} from 'src/reducers/paidinvoice';
import { commonDateFormat, createInputElementPay } from './paymentAction';

export interface DataParamType {
    fdate: string | null;
    tdate: string | null;
    userId: string;
}

export const getUserPaidInvoiceData = (startDate: Date, endDate: Date) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const sessionid = getState().user.userDetails.s || '';

        const dataParam: DataParamType = {
            fdate: commonDateFormat(startDate, 'date') || null,
            tdate: commonDateFormat(endDate, 'date') || null,
            userId: getState().user.userDetails.labCode
        };

        axios({
            method: 'post',
            url: `${getState().environment.API_URL}getPaidInvoices`,
            headers: {
                sessionid: sessionid || ''
            },
            data: dataParam
        }).then(async function (response: AxiosResponse) {
            if (response.data.length === 1) {
                if (response.data[0].receiptno !== '') {
                    const getPaidInvoiceData: PaidInvoiceData[] = response.data;
                    dispatch({ type: STORE_PAIDINVOICE_DATA, getPaidInvoiceData } as AnyAction);
                } else {
                    const getPaidInvoiceData: PaidInvoiceData[] = [];
                    dispatch({ type: STORE_PAIDINVOICE_DATA, getPaidInvoiceData } as AnyAction);
                }
            } else {
                const getPaidInvoiceData: PaidInvoiceData[] = response.data;
                dispatch({ type: STORE_PAIDINVOICE_DATA, getPaidInvoiceData } as AnyAction);
            }

        }).catch(function (error: AxiosError) {
            // ==> console.error(error);
            const getPaidInvoiceData: PaidInvoiceData[] = [];
            dispatch({ type: STORE_PAIDINVOICE_DATA, getPaidInvoiceData } as AnyAction);
        });
    };
};

export const getMyInvoicesData = (startDate: Date, endDate: Date) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const sessionid = getState().user.userDetails.s || '';

        const dataParam: DataParamType = {
            fdate: commonDateFormat(startDate, 'date'),
            tdate: commonDateFormat(endDate, 'date'),
            userId: getState().userProfileData.userProfiledata.custname
        };

        axios({
            method: 'post',
            url: `${getState().environment.API_URL}getMyInvoices`,
            headers: {
                sessionid: sessionid || ''
            },
            data: dataParam
        }).then(async function (response: AxiosResponse) {
            if (response.data.length === 1) {
                if (response.data[0].docid !== '') {
                    const myInvoicesData: MyInvoicesData[] = response.data;
                    dispatch({ type: STORE_MYINVOICES_DATA, myInvoicesData } as AnyAction);
                } else {
                    const myInvoicesData: MyInvoicesData[] = [];
                    dispatch({ type: STORE_MYINVOICES_DATA, myInvoicesData } as AnyAction);
                }
            } else {
                const myInvoicesData: MyInvoicesData[] = response.data;
                dispatch({ type: STORE_MYINVOICES_DATA, myInvoicesData } as AnyAction);
            }

        }).catch(function (error: AxiosError) {
            // ==> console.error(error);
            const myInvoicesData: MyInvoicesData[] = [];
            dispatch({ type: STORE_MYINVOICES_DATA, myInvoicesData } as AnyAction);
        });
    };
};

export const printInvoice = (txn: String, type: String) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const sessionid = getState().user.userDetails.s || '';

        if (txn) {

            const txninfo = {
                key: sessionid,
                invoiceno: txn,
                type: type,
                customer: getState().userProfileData.userProfiledata.custname || '',
                customerAddress1: getState().userProfileData.userProfiledata.address1 || '',
                customerAddress2: getState().userProfileData.userProfiledata.address2 || '',
                customerCountry: getState().userProfileData.userProfiledata.country || '',
                customerEmail: getState().userProfileData.userProfiledata.emailid
            };
            const formElement = document.createElement('form');
            formElement.style.display = 'none';
            formElement.target = '_blank';
            formElement.action = `${getState().environment.API_URL}printInvoice`;
            formElement.method = 'POST';
            formElement.id = 'invoiceprint';
            const valueElement = createInputElementPay(formElement, txninfo);

            document.body.appendChild(valueElement);
            formElement.submit();
        } else {
            return;
        }

    };
};

export const printReceipt = (txn: PaidInvoiceData) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const sessionid = getState().user.userDetails.s || '';

        if (txn.receiptno) {

            const txninfo = {
                key: sessionid,
                receiptno: txn.receiptno,
                paydate: txn.paydate,
                refno: txn.refno,
                createdon: txn.createdon,
                paymode: txn.paymode,
                paidamt: txn.paidamt,
                customer: getState().userProfileData.userProfiledata.custname || '',
                customerAddress1: getState().userProfileData.userProfiledata.address1 || '',
                customerAddress2: getState().userProfileData.userProfiledata.address2 || '',
                customerCountry: getState().userProfileData.userProfiledata.country || '',
                customerEmail: getState().userProfileData.userProfiledata.emailid
            };

            const formElement = document.createElement('form');
            formElement.style.display = 'none';
            formElement.target = '_blank';
            formElement.action = `${getState().environment.API_URL}printReceipt`;
            formElement.method = 'POST';
            formElement.id = 'invoiceprint';
            const valueElement = createInputElementPay(formElement, txninfo);

            document.body.appendChild(valueElement);
            formElement.submit();
        } else {
            return;
        }

    };
};

export const resetPaymentArray = (type: string) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

        if (type === 'myinvoices') {
            const myInvoicesData: MyInvoicesData[] = [];
            dispatch({ type: STORE_MYINVOICES_DATA, myInvoicesData } as AnyAction);
        }
    };
};



// WEBPACK FOOTER //
// ./src/actions/paidInvoiceAction.ts